import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Eye, X } from 'lucide-react';

export default function ImpersonationBanner() {
  const { user, isImpersonating, stopImpersonation } = useAuth();

  if (!isImpersonating) return null;

  const handleStop = async () => {
    try {
      await stopImpersonation();
    } catch (err) {
      console.error('Error stopping impersonation:', err);
    }
  };

  return (
    <div
      className="fixed top-0 left-0 right-0 z-[100] flex items-center justify-center gap-3 py-2 px-4 text-sm font-medium text-white"
      style={{ backgroundColor: '#dc2626' }}
      data-testid="impersonation-banner"
    >
      <Eye size={16} />
      <span>
        Impersonando a <strong>{user?.first_name} {user?.last_name}</strong> ({user?.email})
      </span>
      <button
        onClick={handleStop}
        data-testid="stop-impersonation-btn"
        className="flex items-center gap-1 px-3 py-1 rounded-md text-xs font-bold bg-white/20 hover:bg-white/30 transition-colors"
      >
        <X size={12} /> Detener
      </button>
    </div>
  );
}
